import ActivationStatistics from "./../../general/ActivationStatistics";

export default class DebtsStatistics extends ActivationStatistics {
  constructor() {
    super();
    this.setDebtsStatisticsInitialValue();
  }
  setDebtsStatisticsInitialValue() {
    this.setInitialValue();
    this.totalDebtsMoney = "";
    this.totalDebtsMoneyWithCurrency = "";
    this.totalDebtsMoneyText = "";
    this.totalPaidMoney = "";
    this.totalPaidMoneyWithCurrency = "";
    this.totalPaidMoneyMoneyText = "";
    this.totalRemainderMoney = "";
    this.totalRemainderMoneyWithCurrency = "";
    this.totalRemainderMoneyMoneyText = "";
    this.totalRefundMoney = "";
    this.totalRefundMoneyWithCurrency = "";
    this.totalRefundMoneyMoneyText = "";
    this.paidPercentage = "";
    this.paidPercentageText = "";
    this.remainderPercentage = "";
    this.remainderPercentageText = "";
    this.finishPercentage = "";
    this.finishPercentageText = "";
    this.notFinishPercentage = "";
    this.notFinishPercentageText = "";
    this.isHaveSchedulPercentage = "";
    this.isHaveSchedulPercentageText = "";
    this.notHaveSchedulPercentage = "";
    this.notHaveSchedulPercentageText = "";
    this.canceledDebtPercentage = "";
    this.canceledDebtPercentageText = "";
    this.countDebtsFinish = "";
    this.countDebtsNotFinish = "";
    this.countDebtsCanceled = "";
    this.countDebtsIsHaveSchedul = "";
    this.countDebtsNotHaveSchedul = "";
  }
  fillDebtsStatisticsData(data) {
    if (data) {
      this.fillData(data);
      this.totalDebtsMoney = data.totalDebtsMoney ?? "";
      this.totalDebtsMoneyWithCurrency = data.totalDebtsMoneyWithCurrency ?? "";
      this.totalDebtsMoneyText = data.totalDebtsMoneyText ?? "";
      this.totalPaidMoney = data.totalPaidMoney ?? "";
      this.totalPaidMoneyWithCurrency = data.totalPaidMoneyWithCurrency ?? "";
      this.totalPaidMoneyMoneyText = data.totalPaidMoneyMoneyText ?? "";
      this.totalRemainderMoney = data.totalRemainderMoney ?? "";
      this.totalRemainderMoneyWithCurrency =
        data.totalRemainderMoneyWithCurrency ?? "";
      this.totalRemainderMoneyMoneyText =
        data.totalRemainderMoneyMoneyText ?? "";
      this.totalRefundMoney = data.totalRefundMoney ?? "";
      this.totalRefundMoneyWithCurrency =
        data.totalRefundMoneyWithCurrency ?? "";
      this.totalRefundMoneyMoneyText = data.totalRefundMoneyMoneyText ?? "";
      this.paidPercentage = data.paidPercentage ?? "";
      this.paidPercentageText = data.paidPercentageText ?? "";
      this.remainderPercentage = data.remainderPercentage ?? "";
      this.remainderPercentageText = data.remainderPercentageText ?? "";
      this.finishPercentage = data.finishPercentage ?? "";
      this.finishPercentageText = data.finishPercentageText ?? "";
      this.notFinishPercentage = data.notFinishPercentage ?? "";
      this.notFinishPercentageText = data.notFinishPercentageText ?? "";
      this.isHaveSchedulPercentage = data.isHaveSchedulPercentage ?? "";
      this.isHaveSchedulPercentageText = data.isHaveSchedulPercentageText ?? "";
      this.notHaveSchedulPercentage = data.notHaveSchedulPercentage ?? "";
      this.notHaveSchedulPercentageText =
        data.notHaveSchedulPercentageText ?? "";
      this.canceledDebtPercentage = data.canceledDebtPercentage ?? "";
      this.canceledDebtPercentageText = data.canceledDebtPercentageText ?? "";
      this.countDebtsFinish = data.countDebtsFinish ?? "";
      this.countDebtsNotFinish = data.countDebtsNotFinish ?? "";
      this.countDebtsCanceled = data.countDebtsCanceled ?? "";
      this.countDebtsIsHaveSchedul = data.countDebtsIsHaveSchedul ?? "";
      this.countDebtsNotHaveSchedul = data.countDebtsNotHaveSchedul ?? "";
    } else {
      this.setDebtsStatisticsInitialValue();
    }
  }
}
